<template>
    <div class="plan-select-screen">
        <h2 class="title">
            Choose Your Plan
        </h2>

        <template v-if="isLoading">
            <BaseLoader class="loader" />
        </template>

        <template v-else>
            <div class="plans">
                <PlanSelectOption
                    :billing-plan="billingPlans.find(({ slug }) => slug === 'starter')"
                    :features-list="featuresList"
                    color-palette="blue"
                    :on-select="onSelect"
                />

                <ul class="features">
                    <li v-for="(feature, index) in features" :key="index" class="feature">
                        {{ feature ? feature.description : '' }}
                    </li>
                </ul>

                <PlanSelectOption
                    :billing-plan="billingPlans.find(({ slug }) => slug === 'pro')"
                    :features-list="featuresList"
                    color-palette="purple"
                    :on-select="onSelect"
                />
            </div>
        </template>
    </div>
</template>
<script>
import { mapState } from 'vuex';

/**
 * Internal dependencies.
 */
import PlanSelectOption from './../PlanSelectOption';

export default {
    components: {
        PlanSelectOption,
    },

    props: {
        onSelect: {
            required: true,
            type: Function,
        },
    },

    computed: {
        ...mapState(['billingPlans', 'planFeatures']),

        /**
         * Indicates whether current screen is loading data or not.
         *
         * @returns {boolean} Check result.
         */
        isLoading() {
            return ! this.billingPlans || ! this.planFeatures;
        },

        /**
         * Gets the list of features to display on comparison table.
         *
         * @returns {string[]} Features list.
         */
        featuresList() {
            return [
                'EasyHosting',
                'Analytics',
                'TrackPlayer',
                'ArchivePlayer',
                'StickyPlayers',
                'APIAccess',
                'HiddenPoweredBy',
            ];
        },

        /**
         * Gets the list of features object list.
         *
         * @returns {object[]} Features object list.
         */
        features() {
            return this.featuresList.map((feature) => {
                return this.planFeatures.find(({ key }) => feature === key);
            });
        },
    },
};
</script>
<style scoped lang='scss'>
    @use './PlanSelectScreen.scss';
</style>
